import type { DonutChartCustomTooltipProps } from '../types/pie-chart.config.js';

/**
 * Tooltip slot component.
 */
export const Tooltip = (props: DonutChartCustomTooltipProps) => null;

Tooltip['displayName'] = 'DonutChart.Tooltip';
